import { createFileRoute } from '@tanstack/react-router';
import { InstructorStudentsPage } from '@pages/instructor';

/**
 * Instructor Student Management Page
 *
 * Route: /:locale/instructor/students
 * View and manage enrolled students
 */
export const Route = createFileRoute('/$locale/_authenticated/instructor/students')({
  component: InstructorStudents,
});

function InstructorStudents() {
  return <InstructorStudentsPage />;
}
